import type { ReceiptTemplate } from '../schema';

export const dollarTreeTemplate: ReceiptTemplate = {
  id: 'dollar-tree',
  name: 'Dollar Tree Receipt',
  brand: 'DOLLAR TREE',
  description: 'Dollar store receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'dt-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/dollar-tree.png',
        logoData: '',
        logoWidth: 140,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'STORE #4827',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'dt-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'REG: 02  TRANS: 8472  01/04/26 14:12\nCASSocIATE: JAMES',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'dt-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'dt-item-1', name: 'PARTY PLATES 8CT', quantity: '2', price: '1.25'},
          { id: 'dt-item-2', name: 'NAPKINS 100CT', quantity: '1', price: '1.25'},
          { id: 'dt-item-3', name: 'BALLOONS 12PK', quantity: '1', price: '1.25'},
          { id: 'dt-item-4', name: 'GIFT BAG LG', quantity: '2', price: '1.25'},
          { id: 'dt-item-5', name: 'TISSUE PAPER', quantity: '1', price: '1.25'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'dt-count',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'ITEM COUNT: 7',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'dt-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'dt-subtotal', label: 'SUBTOTAL', value: '8.75', isBold: false, isLarge: false },
          { id: 'dt-tax', label: 'TAX', value: '0.78', isBold: false, isLarge: false },
          { id: 'dt-total', label: 'TOTAL', value: '9.53', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'dt-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'dt-card', label: 'DEBIT', value: '************4144' },
          { id: 'dt-auth', label: 'AUTH', value: '284719' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'dt-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '48278472010426',
        showValue: true,
        width: 1.5,
        height: 40,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'dt-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'EVERYTHING\'S $1.25!\nDOLLARTREE.COM\nRETURNS WITHIN 30 DAYS WITH RECEIPT',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

